class NsNewBestContent extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const opts = { signal: this.abort.signal };
    this.preview = this.querySelector('.ns-newbest-preview');
    if (!this.preview) return;
    this.toggles = [...this.querySelectorAll('[data-preview-toggle]')];
    this.setPreview = (open, restore = false) => {
      this.preview.hidden = !open;
      this.toggles.forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (open) {
        this.preview.focus({ preventScroll: true });
        this.preview.scrollIntoView({ block: 'nearest' });
      } else if (restore && this.opener) {
        this.opener.focus({ preventScroll: true });
        this.opener.scrollIntoView({ block: 'nearest' });
      }
    };
    // The native menu drawer binds close handlers to every button. Capture only
    // our preview controls before those handlers; native back/close stay intact.
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-preview-toggle], [data-preview-close]');
      if (!button || !this.contains(button)) return;
      event.stopPropagation();
      if (button.hasAttribute('data-preview-toggle')) {
        this.opener = button;
        this.setPreview(this.preview.hidden);
      } else this.setPreview(false, true);
    }, { ...opts, capture: true });
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !this.preview.hidden) {
        event.preventDefault();
        event.stopPropagation();
        this.skipEscapeKeyup = true;
        this.setPreview(false, true);
      }
    }, opts);
    this.addEventListener('keyup', event => {
      if (event.key === 'Escape' && this.skipEscapeKeyup) {
        event.stopPropagation();
        this.skipEscapeKeyup = false;
      }
    }, opts);
    this.closest('ns-gallery-menu')?.querySelector('details')?.addEventListener('toggle', event => {
      if (!event.target.open) this.setPreview(false);
    }, opts);
    const drawer = this.closest('side-drawer');
    if (drawer) {
      // The legacy outer drawer expects .section-header-main, while this theme
      // uses #header-component. Supply its real header without changing layout.
      const headerDrawer = this.closest('header-drawer');
      if (headerDrawer && !headerDrawer.header) {
        headerDrawer.header = document.querySelector('.section-header-main') || document.querySelector('#header-component');
      }
      this.observer = new MutationObserver(() => {
        if (!drawer.classList.contains('active')) this.setPreview(false);
      });
      this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.abort = null;
    this.observer?.disconnect();
  }
}
if (!customElements.get('ns-newbest-content')) customElements.define('ns-newbest-content', NsNewBestContent);

